// extracted by mini-css-extract-plugin
export default {"cls1":"FilterScrim-FilterOverlay_cls1__+1Gjm","cls2":"FilterScrim-FilterOverlay_cls2__9US90 FilterScrim-FilterOverlay_cls1__+1Gjm"};